function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "898px",
    height: "780px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 134.5,-0.5 C 388.833,-0.5 643.167,-0.5 897.5,-0.5C 897.5,213.833 897.5,428.167 897.5,642.5C 643.167,642.5 388.833,642.5 134.5,642.5C 134.5,428.167 134.5,213.833 134.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a6a6a6",
    d: "M 490.5,149.5 C 490.5,189.833 490.5,230.167 490.5,270.5C 504.5,270.5 518.5,270.5 532.5,270.5C 540.974,272.137 546.474,277.137 549,285.5C 549.5,311.831 549.667,338.165 549.5,364.5C 512.5,364.5 475.5,364.5 438.5,364.5C 438.5,401.5 438.5,438.5 438.5,475.5C 445.5,475.5 452.5,475.5 459.5,475.5C 459.5,496.167 459.5,516.833 459.5,537.5C 489.5,537.5 519.5,537.5 549.5,537.5C 549.667,566.835 549.5,596.169 549,625.5C 546.987,632.181 542.82,637.014 536.5,640C 407.5,640.667 278.5,640.667 149.5,640C 143.18,637.014 139.013,632.181 137,625.5C 136.333,511.833 136.333,398.167 137,284.5C 139.594,277.572 144.427,273.072 151.5,271C 164.496,270.5 177.496,270.333 190.5,270.5C 190.333,224.165 190.5,177.832 191,131.5C 202.561,68.2797 238.728,26.4464 299.5,6C 356.356,-7.91311 405.856,5.25356 448,45.5C 475.704,74.5819 489.87,109.249 490.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 427.5,147.5 C 427.5,188.167 427.5,228.833 427.5,269.5C 369.5,269.5 311.5,269.5 253.5,269.5C 253.5,226.5 253.5,183.5 253.5,140.5C 260.157,101.005 282.824,75.8387 321.5,65C 368.145,58.5676 401.645,76.4009 422,118.5C 425.773,127.804 427.606,137.471 427.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d7d7d7",
    d: "M 253.5,140.5 C 253.5,183.5 253.5,226.5 253.5,269.5C 311.5,269.5 369.5,269.5 427.5,269.5C 427.5,228.833 427.5,188.167 427.5,147.5C 428.499,188.33 428.832,229.33 428.5,270.5C 369.833,270.5 311.167,270.5 252.5,270.5C 252.168,226.997 252.501,183.663 253.5,140.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d8d8d8",
    d: "M 490.5,149.5 C 491.499,189.33 491.832,229.33 491.5,269.5C 505.344,269.171 519.01,269.504 532.5,270.5C 518.5,270.5 504.5,270.5 490.5,270.5C 490.5,230.167 490.5,189.833 490.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a6a6a6",
    d: "M 612.5,497.5 C 597.5,497.5 582.5,497.5 567.5,497.5C 567.829,482.657 567.496,467.99 566.5,453.5C 557.5,453.5 548.5,453.5 539.5,453.5C 539.5,474.167 539.5,494.833 539.5,515.5C 520.833,515.5 502.167,515.5 483.5,515.5C 483.5,494.833 483.5,474.167 483.5,453.5C 476.5,453.5 469.5,453.5 462.5,453.5C 462.5,431.167 462.5,408.833 462.5,386.5C 553.833,386.5 645.167,386.5 736.5,386.5C 743.695,353.143 763.028,329.977 794.5,317C 831.62,310.143 859.787,322.976 879,355.5C 897.171,389.385 900.504,424.718 889,461.5C 881.176,485.314 866.676,503.814 845.5,517C 818.753,529.367 793.753,526.7 770.5,509C 753.571,494.145 742.238,475.812 736.5,454C 695.168,453.5 653.835,453.333 612.5,453.5C 612.5,468.167 612.5,482.833 612.5,497.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 807.5,350.5 C 821.427,349.214 832.927,353.881 842,364.5C 858.564,387.314 863.898,412.647 858,440.5C 854.684,456.972 846.851,470.805 834.5,482C 815.669,492.956 799.169,490.122 785,473.5C 766.558,445.732 762.891,416.065 774,384.5C 780.105,367.897 791.272,356.563 807.5,350.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 329.5,361.5 C 358.036,358.678 377.203,370.678 387,397.5C 390.927,418.054 385.093,435.221 369.5,449C 376.412,479.396 382.746,509.896 388.5,540.5C 356.167,540.5 323.833,540.5 291.5,540.5C 297.178,510.276 303.178,480.11 309.5,450C 309.128,447.291 307.628,445.457 305,444.5C 293.532,431.308 289.199,415.975 292,398.5C 297.806,379.193 310.306,366.86 329.5,361.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bebebe",
    d: "M 566.5,453.5 C 567.496,467.99 567.829,482.657 567.5,497.5C 582.5,497.5 597.5,497.5 612.5,497.5C 597.342,498.496 582.009,498.83 566.5,498.5C 566.5,483.5 566.5,468.5 566.5,453.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.298d4456eee04f7da61e7bd2ff134e64.svg";
export { ForwardRef as ReactComponent };